const LoginIndexPage = resolve => require(['../pages/auth/login'], resolve)

export default [{
  name: 'login',
  path: 'login',
  component: LoginIndexPage,
  meta: {
    auth: false,
    access: {
      module: 'login',
      page: 'login'
    }
  }
},
 
]




// WEBPACK FOOTER //
// ./src/router/login.router.js